import React from 'react'
import PropTypes from 'prop-types'
import Swipeable from 'react-swipeable'

export default class ShoppingCartProduct extends React.Component {

  state = { isOpened: false }

  onClick = () => { this.setState({ isOpened: !this.state.isOpened }) }

  handleLeftSwipe = (e, x) => { console.log(x); this.setState({ isOpened: true }) }
  handleRightSwipe = (e, x) => { console.log(x); this.setState({ isOpened: false }) }
  handleTap = () => { this.setState({ isOpened: !this.state.isOpened }) }

  onDeleteProduct = () => {
    this.setState({ isOpened: false })
    this.props.onDelete(this.props.productId)
  }

  render () {
    const { title, price, image, variant, enableScroll } = this.props

    let addScrollClass = () => {
      if (enableScroll) {
        return 'js-scroll'
      } else {
        return ''
      }
    }

    return (
      <div className={addScrollClass() + ' in_cart__product' + (this.state.isOpened ? ' in_cart__product-controls-open' : '')}>
        <Swipeable
          onSwipedLeft={this.handleLeftSwipe}
          onSwipedRight={this.handleRightSwipe}
        >
          <div className={`in_cart__product-content ${addScrollClass()}`}>
            <div className={`in_cart__product-image ${addScrollClass()}`} style={{backgroundImage: `url(${image})`}} onClick={this.handleTap} />
            <div className={`in_cart__product-info ${addScrollClass()}`}>
              <div className={`in_cart__product-title ${addScrollClass()}`}>{title}</div>
              {variant.map((v, index, arr) => (
                <div key={index} className={`in_cart__product-variant ${(index === arr.length - 1) ? 'in_cart__product-variant--last' : ''} ${addScrollClass()}`}>
                  <span className='in_cart__product-variant-title'>{v.title}:</span> {v.value}
                </div>
              ))}
              <div className={`in_cart__product-price ${addScrollClass()}`}>${(+price).toFixed(2)}</div>
            </div>
          </div>
        </Swipeable>
        <div className='in_cart__product-controls'>
          <div className='in_cart__product-control in_cart__product-control--remove' onClick={this.onDeleteProduct}>
            <span className='in_cart__product-control-text'>Remove</span>
          </div>
        </div>
      </div>
    )
  }

  static propTypes = {
    title: PropTypes.string,
    price: PropTypes.string,
    image: PropTypes.string,
    variant: PropTypes.array,
    productId: PropTypes.string,
    onDelete: PropTypes.func,
    enableScroll: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/components/cart/ShoppingCartProduct.js